<template>
  <div class="RecordDetail">
    <p class="warning" v-if="carInfo.revStatus!=='closeAccount'">
      <van-icon name="volume" />
      <span>温馨提示：您的接车单已确认，爱车正在维保中，请耐心等待</span>
    </p>
    <div class="page-view">
      <div class="flex-head">
        <span class="black">服务项目</span>
        <span class="black">工时</span>
        <span class="black">价格(元)</span>
      </div>
      <div class="flex-content" v-for="(v, index) in carInfo.servReceiveCarItemsList" :key="index">
        <span class="black">{{v.catalogName}}</span>
        <span class="black">{{v.stdManHour}}</span>
        <span class="orange">￥{{v.price.toFixed(2)}}</span>
      </div>
    </div>
    <div class="page-view">
      <div class="flex-head">
        <span class="black">配件和服务</span>
        <span class="black">数量</span>
        <span class="black">价格(元)</span>
      </div>
      <div class="flex-content" v-for="(v, index) in carInfo.servReceivePartsList" :key="index">
        <span class="black">{{v.partName}}</span>
        <span class="black">{{v.partNum}}</span>
        <span class="black">{{v.price.toFixed(2)}}</span>
      </div>
    </div>
    <div class="page-view order">
      <p>
        <span class="label">服务顾问：</span>
        <span class="text">{{carInfo.revSaName}}</span>
      </p>
      <p>
        <span class="label">联系电话：</span>
        <span class="text">{{carInfo.revSaPhone}}</span>
      </p>
      <p>
        <span class="label">消费门店：</span>
        <span class="text">{{carInfo.brName}}</span>
      </p>
      <p>
        <span class="label">订单编号：</span>
        <span class="text">{{carInfo.revNo}}</span>
      </p>
      <p>
        <span class="label">订单日期：</span>
        <span class="text">{{carInfo.arriveDate}}</span>
      </p>
    </div>
    <!-- <div class="flex-button">
      <div class="left orange">
        <span>应付金额:</span>
        <span>￥100.00</span>
      </div>
      <van-button class="right" type="primary">确认</van-button>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "RecordDetail",
  data() {
    return {
      carInfo: {}
    };
  },
  computed: {},
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      //   queryAcctCustPkg
      try {
        // this.$loading("加载中");
        let result = await this.request("/user/queryServReceiveHistoryDetail", {
          revUuid: this.$route.query.revUuid // data.userCarList[0].carNo
        });
        let carInfo = JSON.parse(result.data);
        console.log(carInfo);
        this.carInfo = carInfo.servReceiveCar;
        // this.carMsg = carInfo.custBaseInfo;
        // this.$store.commit("updateCarMsg", carInfo.custBaseInfo);
        // console.log(result);
        // this.$loadingClose();
      } catch (e) {
        // this.$loadingClose();
        console.log("err", e);
        // this.$error(e.message);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
.RecordDetail {
  height: 100vh;
  background: #f7f7f7;
  overflow: auto;
  .grey {
    color: #979797;
  }
  .black {
    color: #333;
  }
  .blue {
    color: @baseColor;
  }
  .orange {
    color: #ff8c3e;
  }
  .page-view {
    background: #fff;
    padding: @pad;
    margin-bottom: 10px;
  }
  .warning {
    .sc(12px, #ff9f39);
    padding: @pad;
    .flex-center();
    justify-content: flex-start;
    span {
      padding-left: 5px;
    }
  }
  .flex-head {
    .flex-center();
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 10px;
    span {
      flex: 1;
      text-align: center;
      font-size: 14px;
    }
  }
  .flex-content {
    .flex-center();
    padding-top: 10px;
    .orange {
      font-weight: bold;
    }
    span {
      flex: 1;
      text-align: center;
      font-size: 13px;
    }
  }
  .order {
    margin-bottom: 100px;
    p {
      line-height: 28px;
      .grey();
    }
  }
  .flex-button {
    width: calc(~"100%  - " @pad*2);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    .flex-center();
    padding: @pad;
    justify-content: space-between;
    font-size: 14px;
    .orange {
      font-weight: bold;
    }
    .van-button {
      height: 35px;
      line-height: 35px;
      width: 150px;
    }
  }
}
</style>